import {
  RequirementsRequestCode,
  SavedSearchRequest,
} from '@doda/api-client/aspida/@types';
import { OP_VALUE_MAPPINGS } from '@doda/common/src/constants/seo/jobTrendConstants';

type SavedSearchRequestCondition = Omit<SavedSearchRequest, 'name'>;

/**
 * opパラメータを変換して取得
 * @param conditions リクエスト用パラメータ
 * @returns opパラメータ
 */
export const generateOpValues = (conditions: SavedSearchRequestCondition) => {
  let opValues: string[] = [];
  Object.keys(OP_VALUE_MAPPINGS).forEach((key) => {
    const value = conditions[key as keyof typeof OP_VALUE_MAPPINGS];
    if (Array.isArray(value)) {
      value.forEach((item) => {
        const mappedValues = (
          OP_VALUE_MAPPINGS[key as keyof typeof OP_VALUE_MAPPINGS] as Record<
            RequirementsRequestCode,
            string[]
          >
        )[item];
        if (mappedValues) {
          opValues = [...opValues, ...mappedValues];
        }
      });
    } else if (value) {
      opValues = [
        ...opValues,
        OP_VALUE_MAPPINGS[key as keyof typeof OP_VALUE_MAPPINGS] as string,
      ];
    }
  });
  return opValues;
};
